<template>
  <div class="countdown" v-bind:class="{ emerg: isEmergency, dang: isDanger, warn: isWarning}">
    <span v-if="dateHasCome && canBeNegative">-{{ hours | TwoDigits(true) }}:{{ minutes | TwoDigits(true) }}</span>
    <span v-else>{{ hours | TwoDigits }}:{{ minutes | TwoDigits }}</span>
  </div>
</template>

<script>
import TwoDigits from './Filters/TwoDigits.js'
import moment from 'moment'

export default {
  name: 'countdown',
  mounted () {
    this.intervalId = window.setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000 * 60)
  },
  filters: {
    TwoDigits
  },
  props: {
    date: {
      Type: String
    },
    canBeNegative: {
      Type: Boolean
    }
  },
  data () {
    return {
      now: Math.trunc((new Date()).getTime() / 1000)
    }
  },
  destroyed () {
    if (this.intervalId) {
      window.clearInterval(this.intervalId)
    }
  },
  computed: {
    dateInMilliseconds () {
      return Math.trunc(Date.parse(this.date) / 1000)
    },
    seconds () {
      return (this.dateInMilliseconds - this.now) % 60
    },
    minutes () {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60) % 60
    },
    hours () {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60 / 60)
    },
    isWarning () {
      let diff = moment(this.date).diff(moment(), 'minutes')
      return diff < 1440 && diff >= 480
    },
    isDanger () {
      let diff = moment(this.date).diff(moment(), 'minutes')
      return diff < 488 && diff >= 1
    },
    isEmergency () {
      let diff = moment(this.date).diff(moment(), 'minutes')
      return diff < 0
    },
    dateHasCome () {
      let diff = moment(this.date).diff(moment(), 'seconds')
      return diff < 0
    }
  }
}
</script>

<style scoped>
  .countdown.emerg {
    color: #c51a1a;
  }
  .countdown.dang {
    color: #d8610c;
  }
  .countdown.warn {
    color: #c5a712;
  }
</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue